(() => {
  if (customElements.get('pk-product-marks')) return;
  class ProductMarks extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-mark-variants]')?.textContent || '[]');
      this.onChange = (event) => {
        const scope = this.closest('product-info') || this.closest('.shopify-section');
        if (event.target?.name === 'id' && scope?.contains(event.target)) this.update(event.target.value);
      };
      document.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) === this.dataset.section) this.update(data.variant?.id);
        });
      }
    }
    disconnectedCallback() { document.removeEventListener('change', this.onChange); this.unsubscribe?.(); }
    update(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const isMala = this.dataset.malaBase === 'true' && !/(?:27|54)[ -]beads?/i.test(variant.title);
      const mala = this.querySelector('[data-mark="mala"]');
      const iron = this.querySelector('[data-mark="iron"]');
      if (mala) mala.hidden = !isMala;
      if (iron) iron.hidden = !(this.dataset.ironExplicit === 'true' || (isMala && this.dataset.metal === 'true'));
    }
  }
  customElements.define('pk-product-marks', ProductMarks);
})();
